import { useLocation, useNavigate } from "react-router-dom";
import Cookie from "../cookies/Cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe, meState } from "../../../web/models/users/Index";
import MembresiaBar from "../perfil/MembresiaBar";
import { Logout } from "../../../utils/Logout";
import EntradasBar from "../perfil/EntradasBar";
import OfHeader from "./OfHeader";
import apiPrivateAntesala from "../../../config/ConfigPrivate";

const Header = ({ discount }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getParams = new URLSearchParams(location.search);
  const _me = useSelector(meState);
  const me = _me.me;
  const navigate = useNavigate();
  const bar = [
    {
      name: "INICIO",
      link: "/inicio",
      dropdown: null,
      show: true,
    },
    {
      name: "ENTRADAS",
      link: "/entradas",
      dropdown: null,
      show: true,
    },
    {
      name: "CONTENIDOS",
      link: "#",
      show: true,
      dropdown: [
        {
          name: "NOTAS",
          link: "/contenidos/notas",
        },
        {
          name: "VIDEOS",
          link: "/contenidos/videos",
        },
      ],
    },
    {
      name: "SALAS",
      link: "/salas",
      dropdown: null,
      show: true,
    },
    {
      name: "FESTIVALES",
      link: "/festivales",
      dropdown: null,
      show: false,
    },
    {
      name: "DESCUENTOS",
      link: "/descuentos",
      dropdown: null,
      show: discount,
    },
  ];

  const [geolocation, setGeolocation] = useState(
    localStorage.getItem("geolocation")
  );
  const [provincias, setProvincias] = useState(null);
  const [search, setSearch] = useState("");

  const fetch = async (setData, params, url) => {
    const response = await apiPrivateAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  const onClick = (e) => {
    switch (e.target.name) {
      case "search":
        {
          return (window.location.href = `/entradas?search=${search}`);
        }
        break;
      case "login":
        {
          return navigate(`/login`);
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!me) {
      let params = {
        url: "/auth/me",
      };
      dispatch(fetchMe(params));
    }
  }, []);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  useEffect(() => {
    const ofEntradas = () => {
      document.getElementById("of-entradas")?.click();
    };
    if (getParams.get("ofEntradas") && me) {
      ofEntradas();
    }

    if(getParams.get("provincia")){
      setGeolocation(getParams.get("provincia"))
    }
  }, [me]);
  return (
    <div className="container-md ">
      <nav className="navbar navbar-expand-lg bg-white">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src="/assets/img/marca/antesala-logo.svg"
              width="100px"
              alt=""
            />
          </a>
          <button
            className="navbar-toggler d-flex d-md-none"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasTop-header"
            aria-controls="offcanvasTop-header"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse row border-0"
            id="navbarSupportedContent"
          >
            <ul className="col-md-6 navbar-nav justify-content-center align-items-center  mb-2 mb-lg-0 w-full border-0">
              {bar.map((menu) => {
                if (menu.dropdown) {
                  return (
                    <li
                      className={`mx-2 nav-item dropdown ${
                        menu.show ? "" : "d-none"
                      }`}
                    >
                      <a
                        className="nav-link dropdown-toggle fs-7 text-dark fw-bold"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        href="#"
                      >
                        {menu.name}
                      </a>
                      <ul className="dropdown-menu">
                        {menu.dropdown.map((submenu) => {
                          return (
                            <li>
                              <a
                                className="dropdown-item fs-7 text-dark fw-bold"
                                href={submenu.link}
                              >
                                {submenu.name}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  );
                } else {
                  return (
                    <li
                      className={`mx-2 nav-item ${menu.show ? "" : "d-none"}`}
                    >
                      <a
                        className="nav-link active fs-7 text-dark fw-bold"
                        aria-current="page"
                        href={menu.link}
                      >
                        {menu.name}
                      </a>
                    </li>
                  );
                }
              })}
            </ul>

            <div className="col-md-6 d-md-flex justify-content-center align-items-center d-block">
              <div className="d-flex">
                <input
                  className="form-control border border-dark py-1"
                  style={{ borderRadius: "10px 0px 0px 10px" }}
                  type="search"
                  placeholder="Buscar"
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      onClick({ target: { name: "search" } });
                  }}
                />
                <label
                  className="btn btn-dark border-0 me-2 py-1"
                  style={{ borderRadius: "0px 10px 10px 0px" }}
                >
                  <i className="bi bi-search"></i>
                  <button
                    className="d-none"
                    name="search"
                    onClick={(e) => onClick(e)}
                  ></button>
                </label>
              </div>

              <div className="dropdown me-2">
                <button
                  className="btn btn-outline-dark dropdown-toggle w-100 py-1"
                  style={{ borderRadius: "10px" }}
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {geolocation}
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  {provincias
                    ? provincias.map((provincia) => (
                        <li>
                          <label className="dropdown-item">
                            {provincia.provincia}
                            <button
                              className="d-none"
                              onClick={() => {
                                localStorage.setItem(
                                  "geolocation",
                                  provincia.provincia
                                );
                                getParams.set('provincia', provincia.provincia);
                                navigate(`?${getParams.toString()}`);
                                setGeolocation(provincia.provincia);
                                return window.location.reload();
                              }}
                            ></button>
                          </label>
                        </li>
                      ))
                    : ""}
                </ul>
              </div>

              {me ? (
                <div className="dropdown">
                  <button
                    className="dropdown-toggle btn btn-outline-dark d-flex align-items-center py-1 px-2"
                    style={{ borderRadius: "10px" }}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>{`${me.nombre} ${me.apellido}`}</span>
                  </button>
                  <ul className="dropdown-menu">
                    <li
                      className={`${
                        me.roles[0].nombre == "adm" ||
                        me.roles[0].nombre == "prd" ||
                        me.roles[0].nombre == "sala"
                          ? ""
                          : "d-none"
                      }`}
                    >
                      <a
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        href={"/dashboard/perfil"}
                      >
                        Administrador
                      </a>
                    </li>
                    <li>
                      <button
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasTop-membresia"
                        aria-controls="offcanvasTop-membresia"
                      >
                        Membresias
                      </button>
                    </li>
                    <li>
                      <button
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasTop-entradas"
                        aria-controls="offcanvasTop-entradas"
                        id="of-entradas"
                      >
                        Entradas
                      </button>
                    </li>
                    <li>
                      <label className="btn btn-outline-dark w-100 border-0 text-start w-100">
                        Cerrar Sesion
                        <button
                          className="d-none"
                          onClick={(e) => Logout()}
                        ></button>
                      </label>
                    </li>
                  </ul>
                </div>
              ) : (
                <div>
                  <label
                    className="btn btn-outline-dark d-flex align-items-center py-1 px-1"
                    style={{ borderRadius: "20px", maxHeight: "35px" }}
                  >
                    <i className="rounded-pill bi bi-person-circle fs-4 me-1"></i>
                    <span className="Grifter" style={{ fontSize: "12px" }}>
                      INGRESAR
                    </span>
                    <button
                      className="d-none"
                      name="login"
                      onClick={(e) => onClick(e)}
                    ></button>
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
      <MembresiaBar data={me} />
      <EntradasBar data={me} />
      <OfHeader
        bar={bar}
        me={me}
        setSearch={setSearch}
        onClick={onClick}
        provincias={provincias ?? []}
        geolocation={geolocation}
        setGeolocation={setGeolocation}
        getParams={getParams}
        navigate={navigate}
      />
      <Cookie />
    </div>
  );
};

export default Header;
